import { IFieldErrors } from "src/types";
import { ValidationError } from "src/types";
import z from 'zod';

//{"__type":"NotAuthorizedException","message":"Refresh Token has expired"}

export const processResponse = (response: any) => {
  // Process API Gateway lambda response payload structures
  if (response.errorType) {
    if (response.errorType === 'ZodError') {
      const result = new z.ZodError(JSON.parse(response.errorMessage));
      const errors: IFieldErrors = result.format();
      throw new ValidationError(errors);
    } else if (response.errorType === 'ValidationError') {
      const errors: IFieldErrors = JSON.parse(response.errorMessage);
      throw new ValidationError(errors);
    } else {
      throw new Error(`${response.errorType}: ${response.errorMessage}`);
    }
  }
  // Not exception
  return response;
};